<ng-template #template>
  <div [ngClass]="['col-lg-' + width, needpaddingLeft ? 'pr-lg-0' : 'p-lg-0']">
    <div class="card hgs">
      <div class="row card-body">
        <h2 style="position: absolute; padding-left: 19.5px">
          {{ data?.selectedTeam?.teamName }}
        </h2>
        <img
          [src]="
            'img/logo-' +
            data?.selectedTeam?.cssColor +
            '-' +
            simulation +
            (highContrast ? '-hc' : '') +
            '.svg'
          "
          style="
            width: 96px;
            height: 96px;
            margin-left: auto;
            margin-top: 5px;
            margin-right: 30px;
          "
        />
      </div>

      <div
        class="card-footer"
        [ngClass]="[data?.selectedTeam?.cssColor + '-inv']"
      >
        <div class="nav navbar-nav" [hidden]="data.teams.length <= 1">
          <div class="nav-item" ngbDropdown #myDrop3="ngbDropdown">
            <button
              class="nav-link-outline dropdown-toggle"
              style="
                padding: 0;
                color: white;
                background-color: transparent;
                margin-left: 50%;
                margin: 0 auto;
                display: block;
              "
              ngbDropdownToggle
            >
              {{ data?.changeTeamText }}
            </button>
            <div
              class="dropdown-menu shadow"
              aria-labelledby="navbarDropdown"
              ngbDropdownMenu
              style="line-height: 1.5"
            >
              <div class="arrow-up"></div>
              <a
                *ngFor="let team of data?.teams"
                class="dropdown-item dropdown-sub"
                [routerLink]="[]"
                [queryParams]="{ team: team.teamId, region: regionId }"
                [ngClass]="[team.cssColor + '-selector']"
                >{{ team.teamName }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
